import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { Grid } from '@material-ui/core';
import styles from "../team/team.module.css";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 450,
    bgcolor: 'var(--primary-popup-background-color)',
    border: '1px solid var(--primary-popup-stroke-color)',
    borderRadius: '5px',
    //boxShadow: 24,
    p: 4
};

export default function DeleteUserModal(props) {
    const axios = useAxiosPrivate()
    const { setOpen, open, id, setAlert ,loadData} = props
    const handleClose = () => setOpen(false);

    const deleteUser = async (id) => {
        try {
            await axios.delete(`/team/admins/${id}`);
            loadData();
            setOpen(false)
            setAlert({
                showAlert: true,
                severity: 'success',
                message: 'User Successfully Deleted!',
            });
        } catch (e) {
            setAlert({
                showAlert: true,
                severity: 'error',
                message: e?.response?.data?.message,
            });
            setOpen(false)
        }
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} style={{ display: "flex", justifyContent: "center", textAlign: "center", marginBottom: "2rem" }}>
                            <p className={styles.deleteModelText} style={{ margin: 0 }}>
                                Are you sure you want to delete this user?
                            </p>
                        </Grid>
                        <Grid item md={6} style={{ display: "flex", justifyContent: "center" }}>
                            <Button
                                size="large"
                                variant="outlined"
                                onClick={() => deleteUser(id)}
                                sx={{
                                    fontSize: '0.9rem',
                                    lineHeight: 1.25,
                                    fontFamily: '"Poppins", sans-serif',
                                    fontWeight: 500,
                                    minWidth: { sm: 150 },
                                    py: 1.25,
                                    textTransform: 'none',
                                    borderColor: 'var(--primary-text-theme-color)',
                                    color: 'var(--primary-text-theme-color)',
                                    '&:hover': {
                                        borderColor: 'var(--primary-text-theme-color)',
                                        backgroundColor: 'rgba(255, 255, 255, 0.06)',
                                    },
                                }}
                            >
                                Yes
                            </Button>
                        </Grid>
                        <Grid item md={6} style={{ display: "flex", justifyContent: "center" }}>
                            <Button
                                size="large"
                                variant="contained"
                                onClick={() => handleClose()}
                                sx={{
                                    fontSize: '0.9rem',
                                    lineHeight: 1.25,
                                    fontFamily: '"Poppins", sans-serif',
                                    fontWeight: 500,
                                    minWidth: { sm: 150 },
                                    py: 1.25,
                                    textTransform: 'none',
                                    backgroundColor: 'var(--primary-button-background-color)',
                                    color: 'var(--primary-button-text-color)',
                                    opacity: 0.9,
                                    '&:hover': {
                                        backgroundColor: 'var(--primary-button-background-color)',
                                        opacity: 0.8,
                                    },
                                }}
                            >
                                No
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}